import { Clock } from 'three';

export class RenderLoop {
	/*
	* @param {Class} renderClass. Must contain a render method and a renderer(THREE.WebGLRenderer) property
	*/
	constructor( renderClass ) {
		this.renderClass = renderClass;
		
		this.#setMotionEventListeners();

		this.clock = new Clock();
		this.delta = 0;
		// 30 fps
		this.fps = 30;
	}

	start( framesPerSecond, continuos = true ) {
		this.#removeEventListeners();
		this.fps = framesPerSecond ? framesPerSecond : this.fps;
		
		this.doContinuousRender( continuos );
	}

	doContinuousRender( continuos ) {
		this.#removeEventListeners();
		if( continuos ) {
			this.renderClass.renderer.setAnimationLoop( (timestamp, frame) => { this.#loop( timestamp, frame ); });
		} else {
			this.renderClass.renderer.setAnimationLoop( null );
			this.#setMotionEventListeners();
		}
	}

	#loop( timestamp, frame ) {
		this.delta += this.clock.getDelta();
		const interval = 1 / this.fps;

		if ( this.delta  > interval ) {
			this.renderClass.render( this.delta, frame );
			//this.renderClass.render.bind( this.renderClass )(this.delta, frame);
			this.delta = this.delta % interval;
		}
	}

	#setMotionEventListeners() {

		const container = this.renderClass.renderer.domElement;
		
		this._startEvent = () => {
			if ( this.renderClass.renderer.xr.enabled ) {
				this.renderClass.renderer.setAnimationLoop( (timestamp, frame) => this.render.bind( this.renderClass )(timestamp, frame) );
			} else {
				this.delta += this.clock.getDelta();
				const interval = 1 / this.fps;

				if ( this.delta  > interval ) {
					this.renderClass.render.bind( this.renderClass )();
					this.delta = this.delta % interval;
				}
			}
		};
		container.addEventListener('pointermove', this._startEvent );
		document.addEventListener('pointerdown', this._startEvent );
		document.addEventListener('pointerup', this._startEvent );
		container.addEventListener('pointerdrag', this._startEvent );
		container.addEventListener('pointerdragstart', this._startEvent );
		container.addEventListener('pointerdragend', this._startEvent );
		container.addEventListener( 'wheel', this._startEvent );
		document.addEventListener('keyup', this._startEvent );
		document.addEventListener('keydown', this._startEvent );
		window.addEventListener('resize', this._startEvent );
	}

	#removeEventListeners() {
		const container = this.renderClass.renderer.domElement;

		container.removeEventListener('pointermove', this._startEvent );
		document.removeEventListener('pointerdown', this._startEvent );
		document.removeEventListener('pointerup', this._startEvent );
		container.removeEventListener('pointerdrag', this._startEvent );
		container.removeEventListener('pointerdragstart', this._startEvent );
		container.removeEventListener('pointerdragend', this._startEvent );
		container.removeEventListener( 'wheel', this._startEvent );
		document.removeEventListener('keyup', this._startEvent );
		document.removeEventListener('keydown', this._startEvent );
		window.removeEventListener('resize', this._startEvent );

		delete this._startEvent;
	}
}